export * from "./home/home.view";